import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './reports-page.scss';
import { useDispatch, useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import ReportsGrid from './ReportsGrid';
import { getPaginationOpts, getResponseError } from '../../../utils/utils';
import { createExport, loadReportsList } from '../actions';
import ReportsExportModal from './ReportsExportModal';
import notificationDecorator, { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import Loader from '../../../components/base/Loader/Loader';
import { getReportsData } from '../reducer';
import { getSystemData } from '../../System/reducer';
import ModuleUnavailableState from '../../../components/base/ModuleUnavailableState';
import { isMenuUnavailable } from '../../System/serviceAvailability';
import { loadFile } from '../../Client/actions';
import { BACKEND_URL } from '../../../configs';

export default function ReportsPage() {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState(false);
  const { formatMessage } = useIntl();
  const [showExportModal, setShowExportModal] = useState(false);

  const {
    reportsList, reportsListMeta, loadingReportsList,
  } = useSelector(getReportsData);
  const { serviceAvailability } = useSelector(getSystemData);
  const isModuleUnavailable = isMenuUnavailable(serviceAvailability, 'menu.reports-page');

  const loadData = opts => {
    if (isModuleUnavailable) {
      return Promise.resolve([]);
    }

    const paginationOpts = getPaginationOpts(reportsListMeta, opts);
    const requestData = {
      ...paginationOpts,
    };
    const p1 = dispatch(loadReportsList(requestData)).catch(() => {});
    return Promise.all([p1]);
  };

  const handleDownloadDocument = item => {
    if (!item?.id) {
      return;
    }

    const link = `${BACKEND_URL}/proxy/report/v1/reports/${item.id}/download`;
    const filename = `${item?.report_name || item.id}.xlsx`;

    dispatch(loadFile(link)).then(data => {
      fileDownload(data, filename);
    })
      .catch(() => {
        notificationDecorator({
          title: formatMessage({ id: 'file.load.title' }),
          message: formatMessage({ id: 'file.load.message.error' }),
          isError: true,
        });
      });
  };

  const handleExport = item => {
    if (!item) {
      return;
    }

    successNotification('Сводный отчет по сессиям', 'Запуск процесса формирования отчета');
    dispatch(createExport({
      pool: {
        ...item,
      },
    })).then(() => {
      successNotification('Сводный отчет по сессиям', 'Процесс формирования отчета завершен');
      setSelectedRow(true);
      dispatch(loadReportsList()).catch(() => {});
    }).catch(response => errorNotification('Сводный отчет по сессиям', getResponseError(response)));

    setShowExportModal(false);
  };

  useEffect(() => {
    if (isModuleUnavailable || !selectedRow) {
      return;
    }

    dispatch(loadReportsList()).catch(() => {});
  }, [dispatch, selectedRow, isModuleUnavailable]);

  return (
    <div className="reports-page">
      <div className="reports-wrapper">
        <div className="reports-inputs-box">
          <div className={classNames('reports-info', { variant: selectedRow })}>
            {
              selectedRow ? (
                <div className="path">
                  <span className="path-main" onClick={() => setSelectedRow(false)}>{formatMessage({ id: 'menu.reports-page' })}</span> / <span>Таблица отчетов</span>
                </div>
              ) : null
            }
            <PageHeader header={formatMessage({ id: 'menu.reports-page' })}>
              <div className="header-loader">
                <Loader loading={loadingReportsList} />
              </div>
            </PageHeader>
          </div>
        </div>
        {isModuleUnavailable ? <ModuleUnavailableState /> : null}
        { !isModuleUnavailable && !selectedRow ? (
          <>
            <div className="f4">Отчёты</div>
            <div className="report-item-box" onClick={() => setSelectedRow(true)}>
              <div className="report-item-box-title">Экспорт отчетов</div>
              <div className="report-item-box-description">Автоматические отчёты и отчеты, требующие длительное время для формирования</div>
            </div>
            <div className="f4">Парковочные сессии</div>
            <div className="report-item-box" onClick={() => setShowExportModal(true)}>
              <div className="report-item-box-title">Сводный отчет по сессиям</div>
              <div className="report-item-box-description">Информация о парковочных сессиях за указанный период с краткой информацией об оплате</div>
            </div>
          </>
        ) : null }
        { !isModuleUnavailable && selectedRow ? <ReportsGrid reportsListMeta={reportsListMeta} loadData={loadData} data={reportsList} handleDownloadDocument={handleDownloadDocument} /> : null }
        { !isModuleUnavailable && showExportModal ? <ReportsExportModal setShowExportModal={setShowExportModal} handleExport={handleExport} /> : null }
      </div>
    </div>
  );
}
